import { TableContainer, type StackProps } from '@chakra-ui/react';

export type UiTableContainerProps = StackProps;

export const UiTableContainer = TableContainer;
